<template>
  <DetailsPageTitle :title="$t('static.privacy.title')"></DetailsPageTitle>
  <div dir="ltr" class="paper">
    <h4>RETURN AND REFUND POLICY</h4>
    <p>
      Taza Handicraft Company regards all sales as final, and hence cannot
      accept any items for exchange or credit.
    </p>
    <h4>PRODUCT DEFECTS</h4>
    <p>
      We do not accept returns or exchanges unless the item you purchased is
      defective. If you receive a defective item, please contact us at
      shop@Tazaarabia.com with details of the product and the defect.
    </p>
    <p>
      Notification of such a defect should be made within two days of receipt of
      the item, and will be deemed as defective by an email from us entitling
      you to such a refund.
    </p>
    <p>
      Taza will refund you in the form of account store credit which can be
      reused for another purchase.
    </p>
    <p>
      All your store credit has no expiry date and can be used anytime for a new
      order on our website. Our team shall do their utmost to ensure your
      satisfaction and the ratification of any issues that may arise.
    </p>
    <h4>SHIPPING</h4>
    <p>
      Refunds do not include any shipping and handling charges shown on the
      packaging slip or invoice. Shipping charges for all returns must be
      prepaid and insured by you. You are responsible for any loss or damage to
      goods during shipment. Shipping and handling charges are not refundable.
      Any amounts refunded will not include the cost of shipping.
    </p>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
